import { createApi } from "@reduxjs/toolkit/query/react";
import { btBaseQuery } from "../../Common/common";

// Define a service using a base URL and expected endpoints
export const worksheet4Api = createApi({
	reducerPath: "worksheet4Api",
	baseQuery: btBaseQuery,

	endpoints: (builder) => ({
		getDetails: builder.query<any, { id: string; fy: any }>({
			query: ({ id, fy }) => `worksheet4/${id}/${fy}`,
		}),
	}),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetDetailsQuery } = worksheet4Api;
